import moment from 'moment'
import { Button } from '@heroui/react'
import { useBilling } from '@/hooks/useBilling'
import { SubscriptionStatus } from '@interfaces/auth'

const PaymentHeader = () => {
  const { subscription, onSubscribe } = useBilling()
  if (!subscription?.status || subscription.status == SubscriptionStatus.Active) return null

  // Dynamic content based on subscription status
  const getContent = () => {
    switch (subscription.status) {
      case SubscriptionStatus.Unpaid:
      case SubscriptionStatus.PastDue:
        return {
          title: 'Your subscription has been finished. Please renew your subscription.',
          ctaText: 'Renew now',
        }
      case SubscriptionStatus.Canceled:
        return {
          title: 'Your subscription has been canceled. Please reactivate to continue.',
          ctaText: 'Upgrade now',
        }
      case SubscriptionStatus.Trialing: {
        const daysLeft = subscription.trial_end
          ? moment(subscription.trial_end).diff(moment().add(-1, 'days'), 'days')
          : 0
        return {
          title:
            daysLeft <= 1
              ? 'Your trial ends today'
              : `Your free trial ends in ${daysLeft} days — Upgrade to keep working without limits.`,
          ctaText: 'Upgrade now',
        }
      }
      case SubscriptionStatus.Paused:
        return {
          title: '<b>Your free trial has ended.</b> Your documents are still here — upgrade to edit and use AI again.',
          ctaText: 'Upgrade to continue',
        }
      default:
        return {
          title: '',
          ctaText: '',
        }
    }
  }

  const { title, ctaText } = getContent()

  return (
    <div className="flex h-[3rem] items-center justify-center gap-4 rounded-lg bg-[#fff9ca] px-4 py-[0.5rem] text-sm md:px-6">
      {title && <div dangerouslySetInnerHTML={{ __html: title }} />}

      <Button color="primary" onPress={() => onSubscribe()} className="h-[2rem] text-white" variant="solid">
        {ctaText}
      </Button>
    </div>
  )
}

export default PaymentHeader
